import { render, staticRenderFns } from "./Cooperate.vue?vue&type=template&id=3262bf75&scoped=true&"
import script from "./Cooperate.vue?vue&type=script&lang=ts&"
export * from "./Cooperate.vue?vue&type=script&lang=ts&"
import style0 from "./Cooperate.vue?vue&type=style&index=0&id=3262bf75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3262bf75",
  null
  
)

component.options.__file = "Cooperate.vue"
export default component.exports